module.exports = __webpack_public_path__ + "static/media/utor_za_kotac.33131756.png";